// Import firebase services
import { firebaseAuth } from '@/firebase/firebase-config'

export const InvoicesRepository = {

    /*
	**  Set up the data
	*/

	data: () => ({

        new_rent_invoice: {
			id: null,
			type: 'invoice.rent',
			meta: {
				created_at: moment().unix(),
				updated_at: moment().unix(),
				deleted_at: null,
				app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi',
				version: 1
			},
			attributes: {
				status: 'draft', // draft, open, paid, uncollectible, void
				collection_method: 'electronic',
				proration: {
					prorated: false,
					amount: 0
				},
				due_on: {
					date: null
				},
				late_policy: {
					date: null
				},
				notification: {
					date: null,
					days_in_advance: 0
				},
				description: null,
				charge: {
					currency: 'usd',
					policy_late_fee: 0,
					amount: 0,
					subtotal: 0,
					total: 0,
					total_paid: 0,
					tax: 0,
					transaction_fee: 0,
					card_fees: {
						stripe: {
							amount: 0,
							cents: Number(process.env.VUE_APP_STRIPE_CARD_FEE_CENTS),
							percentage: Number(process.env.VUE_APP_STRIPE_CARD_FEE_PERCENT)
						},
						platform: {
							amount: 0,
							percentage: Number(process.env.VUE_APP_PLATFORM_FEE_PERCENT)
						},
						total_fees: 0,
						connect_account_amount: 0
					},
					ach_fees: {
						stripe: {
							amount: 0,
							percentage: Number(process.env.VUE_APP_STRIPE_ACH_FEE_PERCENT)
						},
						platform: {
							amount: 0,
							percentage: Number(process.env.VUE_APP_PLATFORM_FEE_PERCENT)
						},
						total_fees: 0,
						connect_account_amount: 0
					}
				},
				line_items: [
					{
						amount: 0,
						type: 'rent', // Options: rent, late_fee, security_deposit, tax
						description: null,
						paid: false,
						paid_amount: 0
					}
				]
			},
			links: null,
			metrics: null,
			relationships: {
				company: null,
				resident: null,
				user: firebaseAuth.currentUser.uid,
				lease: null,
				unit: null,
				rent: null,
				property: null,
				payment: null,
				stripe: {
					payment: null
				}
			}
		}

    }),

    /*
	**  Set the methods
	*/

	methods: {

        resetNewRentInvoiceProp: function() {

			// Reset the prop
			this.new_rent_invoice = {
				id: null,
				type: 'invoice.rent',
				meta: {
					created_at: moment().unix(),
					updated_at: moment().unix(),
					deleted_at: null,
					app_id: '1:KA82LQU7lsJy:eKwkfzaQy4aM:HKUl9ACoGeAQ:j1xHCCBLS7UQ:yok9xA1wrkZi',
					version: 1
				},
				attributes: {
					status: 'draft', // draft, open, paid, uncollectible, void
					collection_method: 'electronic',
					proration: {
						prorated: false,
						amount: 0
					},
					due_on: {
						date: null
					},
					late_policy: {
						date: null
					},
					notification: {
						date: null,
						days_in_advance: 0
					},
					description: null,
					charge: {
						currency: 'usd',
						policy_late_fee: 0,
						amount: 0,
						subtotal: 0,
						total: 0,
						total_paid: 0,
						tax: 0,
						transaction_fee: 0,
						card_fees: {
							stripe: {
								amount: 0,
								cents: Number(process.env.VUE_APP_STRIPE_CARD_FEE_CENTS),
								percentage: Number(process.env.VUE_APP_STRIPE_CARD_FEE_PERCENT)
							},
							platform: {
								amount: 0,
								percentage: Number(process.env.VUE_APP_PLATFORM_FEE_PERCENT)
							},
							total_fees: 0,
							connect_account_amount: 0
						},
						ach_fees: {
							stripe: {
								amount: 0,
								percentage: Number(process.env.VUE_APP_STRIPE_ACH_FEE_PERCENT)
							},
							platform: {
								amount: 0,
								percentage: Number(process.env.VUE_APP_PLATFORM_FEE_PERCENT)
							},
							total_fees: 0,
							connect_account_amount: 0
						}
					},
					line_items: [
						{
							amount: 0,
							type: 'rent', // Options: rent, late_fee, security_deposit, tax
							description: null,
							paid: false,
							paid_amount: 0
						}
					]
				},
				links: null,
				metrics: null,
				relationships: {
					company: null,
					resident: null,
					user: firebaseAuth.currentUser.uid,
					lease: null,
					unit: null,
					rent: null,
					property: null,
					payment_intent: null
				}
			}

		}

    }

}